module.exports = __webpack_public_path__ + "img/logo.2ce2d6a9.svg";